import { render, staticRenderFns } from "./ConfigureDynamicAttribute.vue?vue&type=template&id=29b9da24"
import script from "./ConfigureDynamicAttribute.vue?vue&type=script&lang=js"
export * from "./ConfigureDynamicAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports